import type { ComponentType } from 'react';
import React from 'react';

import type { IToolbarItem, ToolbarButtonRenderers } from './../ricos-types';
import { ToolbarButtonSeparator } from './../toolbars-ui';

import { CustomButton, ToggleButton } from './components/buttons';

type CustomIToolbarItem = IToolbarItem & { presentation?: { component?: ComponentType } };

export const defaultToolbarItemsRenderers: ToolbarButtonRenderers = {
  separator: () => {
    return <ToolbarButtonSeparator />;
  },
  delete: (toolbarItem: IToolbarItem) => {
    return (
      <ToggleButton
        onClick={(e: $TSFixMe) => toolbarItem.commands.delete(e)}
        toolbarItem={toolbarItem}
      />
    );
  },
  default: (toolbarItem: IToolbarItem) => {
    return (
      <ToggleButton
        onClick={(e: React.MouseEvent) => toolbarItem.commands.click(e)}
        toolbarItem={toolbarItem}
      />
    );
  },
  custom: (toolbarItem: CustomIToolbarItem) => {
    const CustomComponent = toolbarItem.presentation?.component ?? React.Fragment;
    return (
      <CustomButton toolbarItem={toolbarItem}>
        <CustomComponent />
      </CustomButton>
    );
  },
};
